/**
 * Affichage monétaire.
 *
 * Le front ne calcule JAMAIS un prix : il ne fait que formater ce que le
 * backend a décidé. La devise vient de la réponse serveur, jamais d'une
 * constante — l'édition 2027 peut se tenir dans une autre devise sans
 * toucher une ligne de code.
 */

export interface MoneyAmount {
  amount_minor: number
  currency: string
}

const MINOR_UNITS: Record<string, number> = {
  // Devises sans sous-unité, à compléter au besoin.
  XAF: 0,
  XOF: 0,
  JPY: 0,
}

export function minorUnits(currency: string): number {
  return MINOR_UNITS[currency.toUpperCase()] ?? 2
}

export function formatMoney(money: MoneyAmount, locale: string): string {
  const digits = minorUnits(money.currency)
  const value = money.amount_minor / 10 ** digits
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: money.currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value)
}
